'use client';

import { Button } from '@ahafood/ui/components/button';

interface NoSearchResultsProps {
  searchQuery: string;
  onClearSearch: () => void;
}

export function NoSearchResults({
  searchQuery,
  onClearSearch,
}: NoSearchResultsProps) {
  return (
    <div className="p-4 text-center">
      <div className="flex flex-col items-center justify-center py-12">
        <div className="text-6xl mb-4">🔍</div>
        <h3 className="text-lg font-medium text-neutral-80 mb-2">
          Không tìm thấy món
        </h3>
        <p className="text-neutral-50 mb-4">
          Không tìm thấy kết quả cho "{searchQuery}". Vui lòng thử tìm kiếm với
          từ khóa khác.
        </p>
        <Button variant="destructive" onClick={onClearSearch}>
          Xóa tìm kiếm
        </Button>
      </div>
    </div>
  );
}
